export const brandColors = {
  SUBZERO: 'primaryBlue',
  WOLF: 'primaryRed',
  SUBZERO_HEX: '#0081C6',
  WOLF_HEX: '#C0311A'
};

export const PRIMARY_GRAY = '#757575';
export const WHITE = '#FFFFFF';
